(() => {
	function init() {
		const slider = document.querySelector('[data-slider="timeline"]');

		new KeenSlider(slider, {
			slidesPerView: 4,
			mode: 'free',
			spacing: 40,
			loop: false
		});
	}

	// Events
	// ----------------------------------------

	$DOC.ready(() => {
		if ($BODY.hasClass('garden-center-page')) {
			init();
		}
	});

	$WINDOW.on('page:load-completed', (e) => {
		if ($BODY.hasClass('garden-center-page')) {
			init();
		}
	});
})();
